import { render, staticRenderFns } from "./LogoAxRoadIcon.vue?vue&type=template&id=446b6a75&scoped=true&"
import script from "./LogoAxRoadIcon.vue?vue&type=script&lang=js&"
export * from "./LogoAxRoadIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogoAxRoadIcon.vue?vue&type=style&index=0&id=446b6a75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b6a75",
  null
  
)

export default component.exports